// useScrollToTop によるルート変更時のスクロールリセットを、次の1回だけスキップするためのフラグ。
// 一覧⇔詳細のように同一ルート内で search パラメータのみ変わる遷移で、
// 呼び出し側がスクロール位置を自前で復元したい場合に navigate の直前で skipNextScrollReset() を呼ぶ。
let skipNext = false;

export const skipNextScrollReset = () => {
  skipNext = true;
};

export const consumeSkipScrollReset = () => {
  const value = skipNext;
  skipNext = false;
  return value;
};

// ブラウザバック/フォワード(popstate)によるルート変更かどうか。
// ブラウザ標準の挙動に合わせ、popstate 由来の遷移ではスクロールをリセットしない。
// TanStack Router の popstate 処理（内部で React の effect が同期実行される）より
// 先に検知する必要があるため、モジュール読み込み時にリスナーを登録する。
// React の effect 実行が次の macrotask まで遅延してもフラグが失われないよう、
// setTimeout でのクリアではなく読み取り時に消費する。
let popStateNavigation = false;
if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    popStateNavigation = true;
  });
}

export const consumePopStateNavigation = () => {
  const value = popStateNavigation;
  popStateNavigation = false;
  return value;
};
